/**
 * Redux slice for meetings page state.
 * Stores todayQueryArgs so the meeting detail can reuse the same RTK Query args
 * as useSearchData and get a cache hit (no duplicate request, no list remount).
 */
import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'meetingsPage',
  initialState: { todayQueryArgs: null, openMeetingDate: null, scrollAnchorDate: null },
  reducers: {
    setTodayQueryArgs: (state, action) => {
      state.todayQueryArgs = action.payload
    },
    // Date (YYYY-MM-DD) of the meeting currently open in the right rail, or null when the rail is
    // closed. The date selector reflects it so the label shows where the user is in the feed.
    setOpenMeetingDate: (state, action) => {
      state.openMeetingDate = action.payload
    },
    // Display-only date from scroll position (date group closest to viewport center). Does not
    // change the view_date URL param or re-query the feed.
    setScrollAnchorDate: (state, action) => {
      state.scrollAnchorDate = action.payload
    },
  },
})

export const { setTodayQueryArgs, setOpenMeetingDate, setScrollAnchorDate } = slice.actions
export const todayQueryArgsSelector = (state) => state.meetingsPage?.todayQueryArgs ?? null
export const openMeetingDateSelector = (state) => state.meetingsPage?.openMeetingDate ?? null
export const scrollAnchorDateSelector = (state) => state.meetingsPage?.scrollAnchorDate ?? null
export const reducer = slice.reducer
